
import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import WizardCart from "@/views/_components/WizardCart.vue";
import { CartItem, CartItemType } from "@/types/cart-item";
import { namespace } from "vuex-class";
import CheckoutCoverage from "@/views/_components/CheckoutCoverage.vue";
import { Cart } from "@/types/Cart";
import StatusComponent from "@/components/StatusComponent.vue";
import Loader from "@/components/Loader.vue";
import ElementLoader from "@/components/ElementLoader.vue";
const { State } = namespace("Root");
import { Country } from "@/types/Country";
import ValidationMessage from "@/views/_components/ValidationMessage.vue";
import ProductService from "@/services/ProductService";
import IProduct from "@/models/protocols/IProduct";
import countryService from "@/services/CountryService";
import ICountry from "@/models/protocols/ICountry";

@Component({
  components: {
    WizardCart,
    CheckoutCoverage,
    StatusComponent,
    Loader,
    ElementLoader,
    ValidationMessage,
  },
})
export default class WizardOne extends Vue {
  @State("cart") cart!: Cart;
  @Prop({ default: "" }) state_by_zip!: string;

  contunueHTML = "&nbsp;";
  loading = false;
  cats_loaded = false;
  validated_list: any[] = [];
  validated = false;
  timeout: any;
  button_loading = false;
  showStateProvince = true;
  submitted = false;
  err_status = -1;
  err_message = "Please fill in required fields.";

  wag_cats: IProduct[] = [];

  regions: ICountry[] = [];

  constructor() {
    super();
  }

  scrollToTop() {
    window.scrollTo(0, 0);
  }

  /**
   * Gets status component
   */
  status() {
    return this.$refs.status as any;
  }

  async mounted() {
    const regions = await countryService.getRegions();
    const countries = Object.keys(regions);
    this.regions = [];
    if (countries && countries.length > 0) {
      countries.forEach((country) => {
        this.regions.push(...regions[country]);
      });
    }
    // eslint-disable-next-line no-console
    console.log(this.regions);
    if (this.state_by_zip !== "") {
      // this.stateSelected(this.state_by_zip);
      this.cart.stateValue = this.state_by_zip;
      this.cart.persist();
      if (this.state_by_zip !== "Florida") {
        this.showStateProvince = false;
      }
    }

    this.configureValidation();
    this.cart.clearIfCompleted();
    if (this.cart.items.length == 0) {
      this.$router.push({ name: "home" });
    }
    // } else {
    //   this.cart.items.slice(1).forEach((item) => {
    //     item.customer.state = { ...this.cart.items[0].customer.state };
    //   });
    // }
    try {
      this.loading = true;
      this.wag_cats = await ProductService.all();
      this.loading = false;
      this.cats_loaded = true;
      this.scrollToTop();
      this.checkIfValidated();
    } catch (error) {
      this.loading = false;
    }

    if (this.$route.query.redirectMsg !== undefined) {
      this.submitted = true;
    }

    //TODO where is item.customer.state used?
    // if (this.cart.stateValue !== "") {
    //   const tempState: Country = new Country();
    //   let selectedState: any = {
    //     ...this.regions.find((c) => c.title === this.cart.stateValue),
    //   };
    //   if (Object.keys(selectedState).length > 0) {
    //     tempState.short = selectedState.short;
    //     tempState.title = selectedState.title;
    //     tempState.id = selectedState.id;
    //   }
    //   this.cart.items.forEach((item) => {
    //     item.customer.state = tempState;
    //   });
    // }
  }

  configureValidation() {
    this.cart.items.forEach((item) => {
      let data = {
        id: item.id,
        validated: false,
      };
      this.validated_list.push(data);
    });

    // Remove the validation object if the item is deleted.
    this.cart.itemRemoved.on(this.itemRemoved);
  }

  itemRemoved(cart_item?) {
    if (!cart_item) {
      return;
    }
    let index = this.validated_list.findIndex((item) => {
      return item.id == cart_item.id;
    });

    if (index >= 0) {
      this.validated_list.splice(index, 1);
      this.checkIfValidated();
    }

    // If we don't have items, go home.
    if (this.cart.items.length == 0) {
      this.timeout = setTimeout(this.goHome, 5000);
    }
  }

  beforeDestroy() {
    this.cart.itemRemoved.off(this.itemRemoved);
  }

  goHome() {
    clearTimeout(this.timeout);
    this.$router.push({ name: "home" });
  }

  //TODO refactor
  getWagCategory(type: CartItemType, name: String) {
    const classcode = Object.keys(this.wag_cats).find((item) => {
      if (name.toLowerCase().includes("watch")) {
        return this.wag_cats[item].name?.includes(name);
      } else {
        return this.wag_cats[item].classcode == type.toString();
      }
    });
    if (classcode) {
      return this.wag_cats[classcode];
    } else {
      return undefined;
    }
  }

  removeFormErrors(target: string) {}

  async onSubmit() {
    this.submitted = true;
    if (this.validated) {
      this.status().clear();
      this.button_loading = true;
      // Fill all items that should match with the first of their type,
      // and fill the info.
      this.cart.items.forEach((item) => {
        if (item.match_with_first) {
          let master = this.cart.getFirstOfType(item.code) as CartItem;
          this.cart.updateMatchedItemsCoverage(master);
        }
      });
      this.button_loading = false;

      this.$router.push({ name: "wizard.two" });
    } else {
      this.scrollToTop();
    }
  }

  coverageValidated(id: any, validated: boolean) {
    let item = this.validated_list.find((item) => {
      return item.id == id;
    });

    if (item) {
      item.validated = validated;
      this.checkIfValidated();
    }
  }

  checkIfValidated() {
    this.validated = this.validated_list.every((item) => {
      return item.validated == true;
    });

    if (this.cart.stateValue == "") {
      this.validated = false;
    }

    if (!this.validated) {
      this.err_status = 2;
    }
  }

  get emptyCountry() {
    return new Country();
  }

  stateSelected(region) {
    this.checkIfValidated();
    // const tempState: Country = new Country();
    // let selectedState: any = {
    //   ...this.regions.find(c => c.short === countryKey)
    // };
    // if (Object.entries(selectedState).length > 0) {
    //   tempState.id = selectedState.id;
    //   tempState.short = selectedState.short;
    //   tempState.title = selectedState.title;
    // }
    // this.cart.items.forEach(item => {
    //   item.customer.state = tempState;
    // });
    // this.cart.stateValue = selectedState.title;
    this.cart.persist();
  }
  stateValidationError() {
    if (
      (this.cart.stateValue == "" && this.submitted) ||
      (this.cart.stateValue === undefined && this.submitted)
    ) {
      return true;
    }
  }

  isStateSelect() {
    if (
      Object.entries(this.cart.items[0].customer.state).length === 0 ||
      this.cart.items[0].customer.state.short === ""
    )
      return false;
    else return true;
  }
}
